import Vue from "vue";
import Vuex from "vuex";
import "./modules/inbox";
import "./modules/snack";

import { storeBuilder } from "./RootState";

Vue.use(Vuex);

export default storeBuilder.vuexStore();
